import styled from 'styled-components'

export const Container = styled.div`
  background-color: var(--black);
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  h1 {
    color: var(--primary);
    font-size: 48px;
    font-weight: 700;
  }
`
export const ContainerForm = styled.div`
  background-color: var(--box-background);
  border-radius: 4px;
  margin-top: 40px;
  form {
    margin: 30px;
    display: flex;
    flex-direction: column;
  }
  form .form-group {
    position: relative;
    margin-bottom: 20px;
    span {
      display: block;
      color: var(--red);
      font-size: 13px;
      font-weight: 500;
      padding-top: 7px;
    }
  }
  form .form-group input {
    width: 300px;
    height: 50px;
    background-color: var(--black);
    border-radius: 4px;
    padding: 15px;
    color: var(--primary);
    &::placeholder {
      color: var(--dark-text-color);
    }
  }
`
export const ContainerRecuperar = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 20px;
  .entrar_link {
    color: var(--primary);
    font-size: 15px;
    font-weight: 400;
    transition: opacity 0.3s ease-in-out;
    opacity: 0.8;
  }
  .entrar_link:hover {
    opacity: 1;
  }
`
